import React, { useEffect } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { getOrgTermsContent } from '../../../../content/utils.js';
import Empty from '../../../Empty.jsx';
import { FormError } from '../../../FormError.jsx';
import { PermissionsLink } from '../../../links/index.jsx';
import RadioOptionsField from '../../../RadioOptionsField.jsx';
import GroupRole from './GroupRole.jsx';
import ProjectRole from './ProjectRole.jsx';

const roleOptions = [
  { label: `${getOrgTermsContent('project')} Role`, value: 'project' },
  { label: 'Group Role', value: 'group' },
];

const additionalFields = { roles: [] };

const PermissionsForm = (props) => {
  const {
    submitError,
    submitFailed,
    submitting,
    handleSubmit,
    selectedGroups,
    onDeleteGroup,
    onGroupSelect,
    values,
    projectId,
    userId,
    role,
    errors,
  } = props;

  useEffect(() => {
    if (role && !values.roles) {
      values.roles = role.roles;

      if (role.roles.length) {
        values.roleType = 'project';
      }

      if (role.groups.length) {
        values.roleType = 'group';
      }
    }
  }, [role, values, projectId]);

  useEffect(() => {
    if (role?.groups.length) {
      values.groups = [];
      selectedGroups.map((group) => (values.groups[group.id] = group.roles));
    }
  }, [role]);

  return projectId ? (
    <form onSubmit={handleSubmit}>
      <Row className="m-b-60">
        <Col xs={12} className="m-b-24">
          <div className="component-sm component-bg-blue component-hide-border component-margin-bottom">
            <h3>Select Role Type</h3>
          </div>

          <p className="communication-help text-muted">
            Role will be replaced in case of editing.
          </p>
        </Col>

        <Col xs={10}>
          <RadioOptionsField
            id="roleType"
            label=""
            name="roleType"
            options={roleOptions}
          />
        </Col>
      </Row>

      {values.roleType ? (
        values.roleType === 'project' ? (
          <ProjectRole errors={errors} submitFailed={submitFailed} />
        ) : (
          <GroupRole
            selectedGroups={selectedGroups}
            onDeleteGroup={onDeleteGroup}
            onGroupSelect={onGroupSelect}
            additionalFields={additionalFields}
            errors={errors}
            submitFailed={submitFailed}
            values={values}
          />
        )
      ) : null}

      <Row className="m-b-48">
        {submitFailed && submitError ? (
          <FormError submitError={submitError} />
        ) : null}
        <Col xs={12}>
          <div className="flex">
            <div>
              <PermissionsLink userId={userId}>
                <Button bsStyle="default">Cancel</Button>
              </PermissionsLink>

              <Button
                className="m-l-12"
                bsStyle="primary"
                disabled={submitting}
                type="submit"
              >
                {submitting ? 'Saving...' : 'Save'}
              </Button>
            </div>
          </div>
        </Col>
      </Row>
    </form>
  ) : (
    <Empty simplified />
  );
};

export default PermissionsForm;
